const Dashboard = () => <>Dashboard</>;

export default Dashboard;
